import { Box, Button } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const LanguageSection = styled(Box)({
  padding: 0,
});

export const LanguageTabsLeft = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1,
  flexWrap: 'wrap',
});

export const LangCompleteBadge = styled(Box)(({ theme }) => ({
  fontSize: '11px',
  fontWeight: 700,
  color: theme.palette.success.main,
  backgroundColor: alpha(theme.palette.success.main, 0.12),
  padding: '0px 4px',
  borderRadius: 3,
  lineHeight: 1.3,
}));

export const LangIncompleteBadge = styled(Box)(({ theme }) => ({
  fontSize: '11px',
  fontWeight: 600,
  color: theme.palette.error.main,
  backgroundColor: alpha(theme.palette.error.main, 0.1),
  padding: '0px 4px',
  borderRadius: 3,
  lineHeight: 1.3,
}));

export const AutoTranslateButton = styled(Button)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 8,
  padding: '4px 10px',
  minHeight: 'unset',
  height: 'auto',
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  border: `1.5px solid ${alpha(theme.palette.primary.main, 0.4)}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
  color: theme.palette.primary.main,
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
    backgroundColor: alpha(theme.palette.primary.main, 0.09),
    borderColor: alpha(theme.palette.primary.main, 0.6),
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    borderColor: 'var(--am-border-mid)',
    color: 'var(--am-text-primary)',
  },
}));
